import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { forbiddenListeners } from '#api/apiListeners'
import type { ReactRouter } from '#types/react-router'

const forbiddenPath = `/forbidden`

export function useForbiddenRedirector(router?: ReactRouter) {
  const navigate = useNavigate()

  useEffect(() => {
    function forbiddenHandler() {
      if (router?.state.location.pathname === forbiddenPath) {
        return
      }
      navigate(forbiddenPath, { replace: true })
    }

    forbiddenListeners.add(forbiddenHandler)

    return () => {
      forbiddenListeners.delete(forbiddenHandler)
    }
  }, [navigate, router])
}
